import { render } from "./TwoFactorChallenge.vue?vue&type=template&id=01a90885"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js"

import "./TwoFactorChallenge.vue?vue&type=style&index=0&id=01a90885&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__